import { format } from 'date-fns-tz';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { useDateLang } from '~/hooks/useDateLang';
import { useTimeFormat } from '~/hooks/useTimeFormat';

interface Props {
  createdAt: string;
}

const OrderDateText = ({ createdAt }: Props) => {
  const { locale } = useDateLang();
  const { t } = useTranslation();
  const { timeFormat } = useTimeFormat();

  return (
    <>
      {t('dayAtTime', {
        day: format(new Date(createdAt), 'MMMM d', {
          timeZone: company.config.timeZone,
          locale,
        }),
        time: format(new Date(createdAt), timeFormat, {
          timeZone: company.config.timeZone,
          locale,
        }),
      })}
    </>
  );
};

export default OrderDateText;
